/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserManagementParametersRecord = {
  createdFrom?: string;
  createdTo?: string;
  direction?: UserManagementParametersRecord.direction;
  orderBy?: string;
  outletId?: string;
  page?: number;
  role?: string;
  search?: string;
  size?: number;
  status?: "PENDING" | "ACTIVE" | "INACTIVE";
};

export namespace UserManagementParametersRecord {
  export enum direction {
    ASC = "ASC",
    DESC = "DESC",
  }
}
